import SplashPage from "./views/temp/deprecated/SplashPage.vue";
import AreYouSelectPage from "./views/temp/deprecated/IsNewPage.vue";

export const DEPRECATED_ROUTES = [
  //
  {
    path: "/temp/deprecated/splash",
    name: "Splash",
    component: SplashPage,
  },
  {
    path: "/temp/deprecated/is-new",
    name: "IsNew",
    component: AreYouSelectPage,
  },
  {
    path: "/temp/deprecated/subscription",
    name: "Subscription",
    component: () => import("./views/temp/deprecated/SubscriptionPage.vue"),
  },
  {
    path: "/temp/deprecated/subscribe",
    name: "Subscribe",
    component: () => import("./views/temp/deprecated/SubscribePage.vue"),
  },
];

import LocalModelerPage from "./views/temp/backdoor/LocalModelerPage.vue";
import CapturePhotoModelPage from "./views/temp/backdoor/CapturePhotoModelPage.vue";
export const BACKDOOR_ROUTES = [
  {
    path: "/temp/backdoor/capture-photo-model",
    name: "CapturePhotoModelPage",
    component: CapturePhotoModelPage,
  },
];

import SandboxLayerPage from "./views/temp/sandbox/SandboxLayerPage.vue";
export const SANDBOX_ROUTES = [
  {
    path: "/temp/sandbox",
    name: "Sandbox",
    component: () => import("./views/temp/sandbox/SandboxPage.vue"),
  },

  {
    path: "/temp/sandbox/layer",
    name: "SandboxLayer",
    component: SandboxLayerPage,
  },
];

import ShowroomPage from "./views/temp/sales/Showroom/ShowroomPage.vue";
export const LAB_ROUTES = [
  {
    path: "/temp",
    name: "Temp",
    component: () => import("./views/temp/TempPage.vue"),
  },
  {
    path: "/s",
    name: "SharePage",
    component: () => import("./views/Share/SharePage.vue"),
    _hideLeftMenu: true,
  },
  // showroom (temp/sales 네임스페이스)
  {
    path: "/temp/sales/showroom",
    name: "Showroom",
    component: ShowroomPage,
    _hideLeftMenu: true,
  },
  {
    path: "/mod-dev",
    name: "ModDev",
    component: () => import("./views/ModDev/ModDevPage.vue"),
  },
  // /short-form 은 메인 routes.js로 승격됨 (SNS > 숏폼 메뉴)
  {
    path: "/temp/sales/home-shopping",
    name: "HomeShopping",
    _hideLeftMenu: true,
    component: () => import("./views/temp/sales/HomeShopping/HomeShoppingPage.vue"),
  },

  // 현재 모델의 모든 애니메이션 보기
  // backdoor/modeler에서 가져오면 될듯

  {
    path: "/temp/backdoor/modeler",
    name: "LocalModelerPage",
    component: LocalModelerPage,
  },
  {
    path: "/temp/backdoor/current-modeler",
    name: "CurrentModelerPage",
    component: () => import("./views/temp/backdoor/CurrentModelerPage.vue"),
  },
];
